import { ResourceType } from '../../../graphQL';

export const CURRENT_CAMPUS_RESOURCE_METADATA: Partial<
  Record<ResourceType, { title: string; description?: string }>
> = {
  [ResourceType.HealthServices]: { title: 'Health Services' },
  [ResourceType.ResidenceLife]: { title: 'Residence Life' },
  [ResourceType.PublicSafetyCampusPolice]: { title: 'Public Safety/Campus Police' },
  [ResourceType.UrgentCareCenter]: { title: 'Urgent Care Center' },
  [ResourceType.LocalHospitalCommunityProvider]: {
    title: 'Local Hospitals or Other Community Providers',
  },
  [ResourceType.PreferredCampusPharmacy]: {
    title: 'Preferred Campus Pharmacy',
    description:
      'If added to org, the location will show up as suggested pharmacy for patients during onboarding.',
  },
  [ResourceType.DisabilityAccessibilityCenter]: { title: 'Disability/Accessibility Center' },
  [ResourceType.LgbtqiaCenter]: { title: 'LGBTQIA+ Center' },
  [ResourceType.Other]: { title: 'Other' },
};

export const LEGACY_CAMPUS_RESOURCE_METADATA: Partial<
  Record<ResourceType, { title: string; description?: string }>
> = {
  [ResourceType.Emergency]: { title: 'Campus Crisis Resources' },
  [ResourceType.AcademicAndAccessibility]: { title: 'Academic Support & Accessibility' },
  [ResourceType.Health]: { title: 'Health & Wellness' },
  [ResourceType.Diversity]: { title: 'Diversity & Inclusion' },
  [ResourceType.Safety]: { title: 'Safety' },
  [ResourceType.Additional]: { title: 'Additional' },
};

export const CAMPUS_RESOURCE_METADATA = {
  ...CURRENT_CAMPUS_RESOURCE_METADATA,
  ...LEGACY_CAMPUS_RESOURCE_METADATA,
};

export const CAMPUS_RESOURCE_TYPES = Object.keys(CAMPUS_RESOURCE_METADATA) as ResourceType[];
export const CURRENT_CAMPUS_RESOURCE_TYPES = Object.keys(
  CURRENT_CAMPUS_RESOURCE_METADATA
) as ResourceType[];

export const isCampusResource = (resourceType: ResourceType): boolean => {
  return resourceType in CAMPUS_RESOURCE_METADATA;
};

export const isCurrentCampusResource = (resourceType: ResourceType): boolean => {
  return resourceType in CURRENT_CAMPUS_RESOURCE_METADATA;
};
